import { useState } from "react";
import useGetHotelDetails from "@/domains/hotel/hooks/useGetHotelDetails";
import useHotelHandlers from "@/domains/hotel/hooks/useHotelHandlers";
import HotelRoomControlContainer from "@/domains/hotel/containers/HotelRoomControlContainer";
import HotelSelectContainer from "@/domains/hotel/containers/HotelSelectContainer";

type Props = {
  hotelId: number | null;
};

export default function HotelCashierContainer({ hotelId }: Props) {
  const [isLockedRoom, setIsLockedRoom] = useState(null);

  const { data, roomData, isLoading, onClose, isPaymentLoading, onPay, load } = useGetHotelDetails(
    hotelId,
    setIsLockedRoom,
  );
  const { isResidentPending, setResident, toggleLockHotel, onCloseControl, isSelling, sell } =
    useHotelHandlers(roomData?.id, roomData?.hasResidence, roomData?.isLocked);

  const handleToggleLock = () => toggleLockHotel(() => setIsLockedRoom((prev) => !prev));

  return roomData ? (
    <HotelRoomControlContainer
      data={roomData}
      isLoading={isLoading}
      isResidentPending={isResidentPending}
      setResident={setResident}
      toggleLockHotel={handleToggleLock}
      isLockedRoom={isLockedRoom}
      onClose={onCloseControl}
      isSelling={isSelling}
      sell={sell}
      refetch={load}
    />
  ) : (
    <HotelSelectContainer
      hotelId={hotelId}
      data={data}
      isLoading={isLoading}
      onClose={onClose}
      isPaymentLoading={isPaymentLoading}
      onPay={onPay}
    />
  );
}
